import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularImageViewerComponent } from 'angular-x-image-viewer';
import { DataService, HelperService } from 'app/services';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from '../confirm-dismiss-dialog/confirm-dismiss-dialog.component';
import { DialogService } from 'primeng/dynamicdialog';
@Component({
  selector: 'app-overlay-image',
  templateUrl: './overlay-image.component.html',
  styleUrls: ['./overlay-image.component.scss'],
})
export class OverlayImageComponent implements OnInit {

  @ViewChild(AngularImageViewerComponent) imageViewers: AngularImageViewerComponent;
  screenSize: { width: number; height: number } = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  image = { name: '', url: '' };
  galleryItems = [];
  imageViewer = [];
  _activeIndex: number = 0;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
  ];
  playingAudioIndex: any = -1;
  playingAudio: any;
  playingTime: any;
  playingIntervalId: any;
  isEditMode: boolean = false;
  recordingTime = 0;
  isAppleDevice: boolean = false;
  workStatus = '';
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#252828',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-plus',
      zoomOut: 'fal fa-minus',
      // next: 'fas fa-caret-right',
      // prev: 'fas fa-caret-left',
      fullscreen: 'fa-expand fal',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: false,
      prev: false,
    },
    customBtns: []
  };
  isFullScreen = false;
  isShow = false;
  isLockedRO = false;
  isFinalized = false;
  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dataService: DataService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogService: DialogService, 
  ) { }
  ngOnInit() {
    this.updateScreenSize();
    const { name, url, images, index, status, isShow, isFinalized } = this.dynamicDialogConfig.data;

    this.isFinalized = isFinalized;
    this.isShow = isShow;
    if (!Array.isArray(this.dynamicDialogConfig.data) && !images) {
      this.image = { name, url };
    } else {
      let indexId = null;
      if (!index) {
        indexId = images.findIndex((obj) => obj.url === url);
      } else {
        indexId = images.findIndex((obj) => obj._id === index);
      }
      this._activeIndex = this.helperService.deepCopy(indexId);
      this.galleryItems = this.helperService.deepCopy(images);
      this.galleryItems.forEach(x => this.imageViewer.push(x.url))
    }
    this.workStatus = status;
    this.isAppleDevice = this.helperService.isAppleDevice();
    this.isLockedRO = this.dataService.isLockedRO;
    this.stopVideoAutoPlaying();
  }

  private updateScreenSize(): void {
    this.screenSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }


  stopVideoAutoPlaying() {
    setTimeout(() => {
      this.galleryItems.map((attachment) => {
        if (attachment.type === 'video') {
          const video = document.getElementById(attachment._id) as HTMLVideoElement;
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    }, 0);
  }

  getIndex(item) {
    let indexId = null;
    if (item.url) {
      indexId = this.galleryItems.findIndex((obj) => obj.url === item.url);
    } else {
      indexId = this.galleryItems.findIndex((obj) => obj._id === item.url._id);
    }
    this._activeIndex = this.helperService.deepCopy(indexId);
  }

  stopPlayer(event?): void {
    this._activeIndex = event || 0;
    const videoElements = document.querySelectorAll('video');
    videoElements?.forEach((video: HTMLVideoElement) => {
      if (!video.paused) {
        video.pause();
        video.currentTime = 0;
      }
    });

    this.galleryItems.forEach((audio) => {
      if (audio.type === 'voice') {
        this.pauseAudio(audio, audio._id);
      }
    });
  }

  close() {
    this.dynamicDialogRef.close();
    this.stopPlayer();
  }

  deleteMedia() {
    if (this.workStatus === 'inprogress') {
      return;
    }

    let content = '';
    const item = this.galleryItems[this._activeIndex];
    if (item.type === 'image') {
      content = `
      <div class="inspection-media mr-2">
        <img src="${item.url}" class="inspection-item-image" alt="" />
      </div>`;
    }
    else if (item.type === 'video') {
      content = `
    <div class="inspection-media mr-2">
        <div class="playVideo"><i class="fa fa-play"></i></div>
        ${item.url && this.isAppleDevice ?
          `<video class="inspection-item-image bg-black-rgb"">
              <source src="${item.url}" type="video/mp4" />
           </video>`
          :
          `<video class="inspection-item-image">
              <source src="${item.url}" type="video/mp4" />
           </video>`}
    </div>`;
    }
    else {
      content = `<div class="inspection-media mr-2">
                  <img src="assets/img/voice-logo.png" alt="voice"/>
                 </div>`;
    }
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'inspection-item-details-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-16 font-700',
        title: `Confirm Delete`,
        isHTML: true,
        message: `${content}
        <div class="font-16 font-400 mb-4 color-black">
        <div>This ${item.type} will be permanently deleted.</div>
        <div>Are you sure you want to proceed?</div>
        </div>
        `,
        button: {
          success: { title: 'Delete', backgroundColor: '#FF4949', styleClass: 'footer-success-btn' },
          cancel: { title: 'Cancel', styleClass: 'footer-discard-btn' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const inspection = this.galleryItems[this._activeIndex];
        this.galleryItems.splice(this._activeIndex, 1);
        this.imageViewer = [];
        this.galleryItems.forEach(x => this.imageViewer.push(x.url))
        this.dataService.sendData(this.dataService.typePassData('delete-media',
          { id: inspection.url }));

        if (this._activeIndex >= this.galleryItems.length) {
          this._activeIndex = this._activeIndex - 1;
        }
        if (this.galleryItems.length === 0) {
          this.close();
        }
      }
      onClose.unsubscribe();
    });
  }


  handlePlayAudio(audio: any, index: number) {
    const indexId = this.galleryItems.findIndex((obj) => obj._id === index);
    if (this.playingAudioIndex > -1) {
      this.galleryItems[this.playingAudioIndex].isPlaying = false;
      clearInterval(this.playingIntervalId);
      if (this.playingAudio) {
        this.playingAudio.pause();
      }
    }
    this.playingTime = 0;
    this.playingAudio = new Audio(audio.url);
    this.playingAudio.play();
    this.playingAudio.addEventListener('play', () => {
      this.playingIntervalId = setInterval(() => {
        if (this.playingTime < audio.recordingTime) {
          this.playingTime += 1;
        }
      }, 1000);
    });

    this.galleryItems[indexId].isPlaying = true;
    this.playingAudio.addEventListener('ended', () => {
      this.galleryItems[this.playingAudioIndex].isPlaying = false;
      clearInterval(this.playingIntervalId);
    });

    this.playingAudioIndex = indexId;
  }

  pauseAudio(audio: any, index: any) {
    const indexId = this.galleryItems.findIndex((obj) => obj._id === index);
    clearInterval(this.playingIntervalId);
    this.playingAudio && this.playingAudio.pause();
    this.galleryItems[indexId].isPlaying = false;
  }

  autoPlayTrigger(url, id) {
    const video = document.getElementById(id) as HTMLVideoElement;
    if (video) {
      video.currentTime = 0;
      video.play();
    }
  }

  renderRecordingTime(time?) {
    if (time) {
      return this.helperService.getFormattedTime(time);
    }

    return this.helperService.getFormattedTime(this.recordingTime);
  }

  handleEvent(event: any) {
    // this._activeIndex = event
  }

  changeIndex(changeIndex) {
    let index = false;
    if (changeIndex) {
      this.galleryItems.map((inspection, i) => {
        if (this._activeIndex === i && !index) {
          if (i <= this.galleryItems.length - 1) {
            index = true;
            const inspection = this.galleryItems[i - 1];
            this.getIndex(inspection);
          }
        }
      });
    } else {
      this.galleryItems.map((inspection, i) => {
        if (this._activeIndex === i && !index) {
          if (i < this.galleryItems.length - 1) {
            index = true;
            const inspection = this.galleryItems[i + 1];
            this.getIndex(inspection);
          }
        }
      });
    }
  }

  disableNavigation(isLeft) {
    if (isLeft) {
      let isValid = false;
      this.galleryItems.map((inspection, i) => {
        if (this._activeIndex === i) {
          if (i === 0) {
            isValid = true;
          } else {
            isValid = false;
          }
        }
      });
      return isValid;
    } else {
      let isValid = false;
      this.galleryItems.map((inspection, i) => {
        if (this._activeIndex === i) {
          if (i >= this.galleryItems.length - 1) {
            isValid = true;
          } else {
            isValid = false;
          }
        }
      });
      return isValid;
    }
  }

}
